module.exports = __webpack_public_path__ + "static/media/scoli-adams-3m.fef6ae2e.png";